// src/pages/PDFViewerPage.js
import React, { useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react'; // یا هر کتابخانه آیکون دیگر
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const stateData = location.state || {};
  const fileUrl = stateData.fileUrl || searchParams.get('url') || '';
  const mediaId = stateData.mediaId || searchParams.get('mediaId') || null;
  const title = stateData.title || searchParams.get('title') || '';

  useEffect(() => {
    if (!fileUrl && !mediaId) {
      navigate(-1);
    }
  }, [fileUrl, mediaId, navigate]);

  if (!fileUrl && !mediaId) {
    return null;
  }

  return (
    <div className="h-screen bg-gray-100 flex flex-col">
      {/* دکمه بازگشت */}
      <div className="bg-gray-800 p-3 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="text-white hover:text-gray-300 transition-colors"
        >
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-white text-lg font-semibold truncate">
          {title || 'مشاهده کتاب'}
        </h1>
      </div>
      
      {/* PDF Viewer */}
      <div className="flex-1">
        <PDFViewer
          mediaId={mediaId}
          fileUrl={fileUrl}
          title={title}
        />
      </div>
    </div>
  );
};

export default PDFViewerPage;